import { api } from '../../app/api.js';
import { mountComponent } from '../../app/component.js';
import { BasketComponent } from "../../components/basket.js";
import { BasketStore } from "../../stores/basket.js";
import { ProductItem } from '../../components/product_item.js';

const state = {
    selected_category_id: null,
    has_categories: false,
    products: [],
}

export default {
    template: `
        <div class="columns col-4 shop">
            <div class="w3">
                <div id="ProductCategories" class="tabs" role="tablist"></div>
                <div id="Products" class="product-list ">
                    <span>Loading products...</span>
                </div>
            </div>
            <div id="basket-container" class="basket-column"></div>
        </div>
    `,

    async onMount() {
        document.body.classList.add("frame");
        const $categories = document.getElementById("ProductCategories");
        const $products = document.getElementById('Products');

        state.current_category_id = localStorage.getItem("shop.category") || null;

        mountComponent(BasketComponent, document.getElementById("basket-container"));

        api.get({
            url: '/products',
            success: response => {
                state.products = response.products || [];

                render_tabs($categories, response.categories || []);
                render_products($products);
            }, error: () => {
                $products.innerHTML = '<span class="error">Unable to load products.<br/>Please check your internet connection or try again later.</span>';
            },
        });

        $categories.addEventListener('click', (e) => {
            const $category = e.target.closest('button[role="tab"]');
            if (!$category) return;

            const category_id = parseInt($category.dataset.categoryId);

            update_selected_category(category_id);
        });

        $products.addEventListener("click", (e) => {
            const btn = e.target.closest(".AddBasket");
            if (!btn) return;

            const $product = btn.closest(".product");
            if (!$product) return;

            const product_id = parseInt($product.dataset.productId)
            const product = state.products.find(product => product.id === product_id);

            BasketStore.add(product);
        });
    },
    async onUnmount() {
        document.body.classList.remove("frame");
    }
};

function render_tabs($categories, categories) {
    if (categories.length === 0) {
        $categories.classList.add('hidden');
        return;
    } else if (categories.length === 1) {
        $categories.classList.add('hidden');
        state.current_category_id = categories[0].id
        return;
    }

    state.has_categories = true;
    $categories.classList.remove('hidden');

    $categories.innerHTML = "";
    let category_found = false;

    categories.forEach(category => {
        const $tab = document.createElement("button");
        $tab.role = "tab";
        $tab.dataset.categoryId = category.id;
        $tab.textContent = category.name;

        if (state.current_category_id === category.id) {
            category_found = true;
            $tab.setAttribute("aria-selected", "true");
            $tab.classList.add('active');
        } else {
            $tab.setAttribute("aria-selected", "false");
            $tab.classList.remove('active');
        }

        $categories.appendChild($tab);
    });

    if (!category_found || state.current_category_id === null) {
        update_selected_category(categories[0].id);
    }
}

function update_selected_category(category_id) {
    state.current_category_id = category_id;

    const $tabs = document.querySelectorAll('#ProductCategories button');

    $tabs.forEach($tab => {
        const category_id = parseInt($tab.dataset.categoryId);

        $tab.classList.toggle('active', category_id === state.current_category_id);

        if (category_id === state.current_category_id) {
            $tab.setAttribute("aria-selected", "true");
        } else {
            $tab.setAttribute("aria-selected", "false");
        }
    })

    render_products();
}

function render_products($products = null) {
    if (!$products) {
        $products = document.getElementById('Products');
    }

    if (state.products && state.products.length > 0) {
        $products.innerHTML = '';
        state.products.forEach(product => {
            if (product.category_id !== state.current_category_id) {
                return
            }

            const item = ProductItem(product);
            $products.appendChild(item);
        });
    } else {
        $products.innerHTML = '<span>No products found.</span>';
    }
}
